import { Component } from '@angular/core';

@Component({
    selector: 'app-loader',
    template: `
        <div class="loader">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
        </div>
    `,
    styleUrls: ['./loader.component.scss']
})

export class LoaderComponent {}